import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "./assets/styles/fonts.css";
import Vue from "vue";
// import authentication from "@/plugins/keycloakPlugin.js";
require("@/assets/filters/filters.js");
require("./http/http-common.js");

Vue.config.productionTip = false;
import FlagIcon from "vue-flag-icon";

import App from "./App.vue";
import router from "./router.js";
import store from "./store";
import i18n from "@/plugins/language/i18n";
import IdleVue from "idle-vue";
import utils from "@/plugins/utils.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfoCircle,
  faCalendarAlt,
  faChevronLeft,
  faPlusCircle,
  faMinusCircle,
  faCheckCircle,
  faUserPlus,
  faUserMinus,
  faArrowAltCircleRight,
  faTrashAlt,
  faTruck,
  faBoxOpen,
  faCoins,
  faUniversity,
  faLongArrowAltRight,
  // faRightLong,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faInfoCircle);
library.add(faCalendarAlt);
library.add(faChevronLeft);
library.add(faPlusCircle);
library.add(faCheckCircle);
library.add(faMinusCircle);
library.add(faUserPlus);
library.add(faUserMinus);
library.add(faArrowAltCircleRight);
library.add(faTrashAlt);
library.add(faTruck);
library.add(faBoxOpen);
library.add(faCoins);
library.add(faUniversity);
library.add(faLongArrowAltRight);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(FlagIcon);

import Cookies from "js-cookie";
import httpServiceCustomer from "@/http/http-customer.js";
import httpServiceUser from "@/http/http-user.js";

Vue.mixin({
  methods: {
    onlyForAdmin(userRole) {
      return userRole === "FAC";
    },
    showModalPopup(elementId, show) {
      var popup = document.getElementById(elementId);
      if (popup) {
        if (show) {
          popup.style.visibility = "visible";
        } else {
          popup.style.visibility = "hidden";
        }
      }
    },
    getUserData() {
      if (Cookies.get("userLink") === null) {
        this.$router.push({
          name: "login",
          params: { loginUserSelected: true },
        });
      }
      if (sessionStorage.getItem("user_data")) {
        let user = JSON.parse(sessionStorage.getItem("user_data"));
        this.getSelectedCompany(user);
        return user;
      } else {
        httpServiceUser.userService
          .getUserData(Cookies.get("userLink"), Cookies.get("token"))
          .then(function (response) {
            // handle success
            return response.data;
          })
          .then((data) => {
            sessionStorage.setItem("user_data", JSON.stringify(data));
            this.getSelectedCompany(data);

            return data;
            // this.loadMessages();
          })
          .catch(function () {
            // handle success
          });
      }
    },
    getSelectedCompany(user) {
      let selectedCompany = JSON.parse(
        sessionStorage.getItem("selectedCompany")
      );

      if (!selectedCompany) {
        selectedCompany = user.companies[0];

        if (!selectedCompany) {
          selectedCompany = {
            company_id: 0,
            role: "FAC",
          };
        } else if (selectedCompany.company_id === 0) {
          selectedCompany.role = "FAC";
        }
        sessionStorage.setItem(
          "selectedCompany",
          JSON.stringify(selectedCompany)
        );
        this.getCustomerData("", selectedCompany.role);
      }
    },
    getCustomerData(source, userRole) {
      if (!userRole){
        userRole = 'CST';
      }
      if (Cookies.get("userLink") === null) {
        // utils.logout();
        // this.$router.push({
        // 	name: "login",
        // 	params: { loginUserSelected: true }
        // });
      }
      
      if (sessionStorage.getItem("customer_data")) {
        this.$store.state.customerDataLoaded = true;
        let customer = JSON.parse(sessionStorage.getItem("customer_data"));
        if (customer.company_id > 0 && userRole !== 'FAC') {
          this.upIntercomInit(
            source + "1",
            customer.company_id,
            customer.name,
            customer.VAT,
            customer.products[0].commercial.first_name +
            " " +
            customer.products[0].commercial.last_name
          );
        }
        return customer;
      } else {
        if (this.$store.state.customerDataLoading) {
          return;
        }
        this.$store.state.customerDataLoaded = false;
        let company = JSON.parse(sessionStorage.getItem("selectedCompany"));
        if (company) {
          this.$store.state.customerDataLoading = true;
          // let company = Cookies.getJSON("selectedCompany");

          httpServiceCustomer.customerService
            .getCustomerData(company.company_id, Cookies.get("token"))
            .then(function (response) {
              // handle success
              return response;
            })
            .catch(() => {
              // handle error
            })
            .then((response) => {
              if (response.status == 200) {
                this.$store.state.customerDataLoaded = true;
                this.$store.state.customerDataLoading = false;
                let customer = response.data;

                sessionStorage.setItem(
                  "customer_data",
                  JSON.stringify(customer)
                );
                if (customer.company_id > 0 && userRole !== 'FAC') {
                  this.upIntercomInit(
                    source + "2",
                    customer.company_id,
                    customer.name,
                    customer.VAT,
                    customer.products[0].commercial.first_name +
                    " " +
                    customer.products[0].commercial.last_name
                  );
                }

                return customer;
              }
            });
        }
        return null;
      }
    },
    upIntercomInit(place, companyCode, companyName, companyVAT, commercial) {
      const crypto = require('crypto');

      const secretKey = process.env.VUE_APP_INTERCOM_SECRET; 
      let userName = decodeURI(encodeURI(this.$keycloak.idTokenParsed.name));
      const userIdentifier = userName + "-" + companyCode; // IMPORTANT: the email for your user

      const hash = crypto.createHmac('sha256', secretKey).update(userIdentifier).digest('hex');

      window.Intercom("update", {
        user_id: userName + "-" + companyCode,
        email: this.$keycloak.idTokenParsed.email,
        name: userName,
        user_hash: hash,
        company: {
          company_id: companyCode,
          name: decodeURI(encodeURI(companyName.trim())),
        },
        custom_attributes: {
          source: "Orders app", //app name
          company_vat: companyVAT,
          sales_person: commercial,
        },
      });
      this.logActivity(
        "INTERCOM", place + " " + companyCode +
        "(" +
        decodeURI(encodeURI(companyName.trim()))   +
        " - " + userName + " / " + this.$keycloak.idTokenParsed.name + " - " +
        companyVAT +
        "): " +
      commercial.trim()
      );
    },
    logActivity(activity, details) {
      let user = JSON.parse(sessionStorage.getItem("user_data"));
      let activityJson = {
        activity: activity,
        details: details,
      };
      httpServiceUser.userService
        .logActivity(user.id, activityJson, Cookies.get("token"))
        .then(function (response) {
          // handle success
          return response;
        })
        .catch(() => {
          // handle error
        });
    },
  },
});

// Vue.use(authentication);



import VueKeycloakJs from '@caassis/vue-keycloak-ts';
console.log("beforeInitapp");

Vue.use(VueKeycloakJs, {
  init: {
    // Use 'login-required' to always require authentication
    // If using 'login-required', there is no need for the router guards in router.js
    onLoad: "login-required",
    checkLoginIframe: false,
    // enableLogging : true,
    useNonce : false,
    // flow: "standard",
    // "ssl-required": "external",
    // resource: "extranet",
    // "public-client": true,
    // "confidential-port": 0,
  },
  config: {
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENTID,
  },
  // VUE_APP_KEYCLOAK_URL=https://auth.uphellas.gr/           
  // VUE_APP_KEYCLOAK_REALM=uphellas
  // VUE_APP_KEYCLOAK_CLIENTID=order
  logout: {
    redirectUri:  process.env.VUE_APP_KEYCLOAK_URL
  },
  // login: {
  //   redirectUri:  "http://localhost:8080"
  // },
  onReady: (keycloak) => {
    const app = new Vue({
      delimiters: ["[[", "]]"],
      router,
      store,
      i18n,
      render: (h) => h(App),
    });
    Vue.use(IdleVue, {
      eventEmitter: app,
      store,
      idleTime: 30 * 60 * 1000, // 30 minutes
      startAtIdle: false,
    });
    app.$mount("#app");

  },
  onInitError: (error) => {
    console.log("onInitError " + error);
  },
  onAuthError: (error) =>{
    console.log("onAuthError " + error);
  }
    
});


// Vue.$keycloak.init({ checkLoginIframe: false }).success(() => {
//   const app = new Vue({
//     delimiters: ["[[", "]]"],
//     router,
//     store,
//     i18n,
//     render: (h) => h(App),
//   });
//   Vue.use(IdleVue, {
//     eventEmitter: app,
//     store,
//     idleTime: 30 * 60 * 1000, // 30 minutes
//     startAtIdle: false,
//   });
//   app.$mount("#app");
// });
